module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('boxWrap', {
    attrs: {
      "name": _vm.name,
      "min": true
    }
  }, [_c('div', {
    staticClass: "bar-wrap"
  }, [_c('img', {
    staticStyle: {
      "margin": "5px 10px",
      "width": "470px"
    },
    attrs: {
      "src": require("../../../../../assets/img/ljc/video.png")
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e059e2d8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/runda/chaye/components/video/index.vue
// module id = 2094
// module chunks = 2